// This is auto generated code, do not edit directly

export const namedOperations = {
	Query: {
		GetQuickSearchResults: 'GetQuickSearchResults',
		GetRecentHistory: 'GetRecentHistory',
		GetCurrentUser: 'GetCurrentUser',
		GetAllCountries: 'GetAllCountries',
		GetAllPicklists: 'GetAllPicklists',
		GetDCRSetup: 'GetDCRSetup',
		GetHCOAutocomplete: 'GetHCOAutocomplete',
		GetAllHCOCountries: 'GetAllHCOCountries',
		GetAllHCPCountries: 'GetAllHCPCountries',
		GetAllSpecialtyGroups: 'GetAllSpecialtyGroups',
		GetHCOAffiliatedHcpSearch: 'GetHCOAffiliatedHcpSearch',
		GetHCOAffiliationSearch: 'GetHCOAffiliationSearch',
		GetHCOById: 'GetHCOById',
		GetHCOSearchAndFilters: 'GetHCOSearchAndFilters',
		GetHCPAffiliationSearch: 'GetHCPAffiliationSearch',
		GetHCPById: 'GetHCPById',
		GetHCPSearchAndFilters: 'GetHCPSearchAndFilters',
		GetRelationshipTypeOptions: 'GetRelationshipTypeOptions',
		GetDCRList: 'GetDCRList'
	},
	Mutation: {
		ClearRecentHistory: 'ClearRecentHistory',
		UpdateRecentProfiles: 'UpdateRecentProfiles',
		UpdateSearchHistory: 'UpdateSearchHistory',
		CreateHCOSearchDownload: 'CreateHCOSearchDownload',
		CreateHCPSearchDownload: 'CreateHCPSearchDownload',
		TrackEntityProfileView: 'TrackEntityProfileView',
		TrackPageView: 'TrackPageView',
		TrackSearch: 'TrackSearch',
		RefreshToken: 'RefreshToken',
		DeleteDcrAttachment: 'DeleteDcrAttachment',
		PostDCR: 'PostDCR',
		SignOut: 'SignOut',
		InitiateAuth: 'InitiateAuth',
		MagicLinkSignIn: 'MagicLinkSignIn',
		PasswordSignIn: 'PasswordSignIn'
	},
	Fragment: {
		AddressSummary: 'AddressSummary',
		Address: 'Address',
		AffiliationBase: 'AffiliationBase',
		ParentAffiliation: 'ParentAffiliation',
		ChildAffiliation: 'ChildAffiliation',
		Affiliation: 'Affiliation',
		HCO: 'HCO',
		HCOCore: 'HCOCore',
		HCOSummary: 'HCOSummary',
		HCPSummary: 'HCPSummary',
		EmailDetails: 'EmailDetails',
		HCP: 'HCP',
		HCPAffiliationLink: 'HCPAffiliationLink',
		AffiliatedHcp: 'AffiliatedHcp',
		License: 'License',
		BadRequest: 'BadRequest',
		Pagination: 'Pagination',
		NotFoundError: 'NotFoundError',
		SearchDownloadResult: 'SearchDownloadResult',
		Country: 'Country',
		SpecialtyGroup: 'SpecialtyGroup',
		HCPSearchAndFilters: 'HCPSearchAndFilters',
		HCOSearchAndFilters: 'HCOSearchAndFilters',
		HCPAffiliationJobTitle: 'HCPAffiliationJobTitle',
		Picklist: 'Picklist',
		DCR: 'DCR'
	}
};
